export const types = {
  MODULE: "machine",
  QUERY: "QUERY",
  SET_QUERY: "SET_QUERY",
  SELECTED_COMPANY_ID: "SELECTED_COMPANY_ID",
  SET_SELECTED_COMPANY_ID: "SET_SELECTED_COMPANY_ID",
};

const state = { QUERY: "", SELECTED_COMPANY_ID: "" };
const mutations = {
  [types.SET_QUERY](state, query) {
    state.QUERY = query;
  },
  [types.SET_SELECTED_COMPANY_ID](state, selectedCompanyId) {
    state.SELECTED_COMPANY_ID = selectedCompanyId;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
